<div class="integrationField">
  <span class="integrationField__name"> {{ date }} - {{ message }} </span>
</div>
